import { render, staticRenderFns } from "./CreatProObjChild.vue?vue&type=template&id=32bbefa6&scoped=true&"
import script from "./CreatProObjChild.vue?vue&type=script&lang=js&"
export * from "./CreatProObjChild.vue?vue&type=script&lang=js&"
import style0 from "./CreatProObjChild.vue?vue&type=style&index=0&id=32bbefa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bbefa6",
  null
  
)

export default component.exports